// HomePage.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { fetchGroups } from '../api/fetchGroups';
import './HomePage.css';

const HomePage = () => {
  const [podcasts, setPodcasts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    fetchPodcasts();
  }, []);

  const fetchPodcasts = async () => {
    try {
      const data = await fetchGroups();
      setPodcasts(data);
    } catch (error) {
      console.error('Error fetching groups:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLinkClick = (linkTitle) => {
    ReactGA.event({
      category: 'User Interaction',
      action: 'Button Click',
      label: linkTitle
    });
  };

  if (loading) {
    return (
      <div className="homepage">
        <div className="loading">Loading podcasts...</div>
      </div>
    );
  }

  return (
    <>
      <div className="homepage">
        <div className="links-container">
          {podcasts.map((podcast) => (
            <Link 
              to={`/${podcast.website_id}`} 
              key={podcast.id}
              onClick={() => handleLinkClick(podcast.name)}
            >
              <button 
                className="link-button" 
                style={{ backgroundColor: '#def339' }}
              >
                {podcast.name}
              </button>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomePage;
